import React from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import ColumnChart from "../charts/generic/ColumnChart"
import ItemNamePercentageCountShape from "../../state/shapes/ItemNamePercentageCountShape"
import { formatDecimalForDisplay } from "../../utils/formatting-utils"

function MeetingNeeds({ exportEndpoint, data, appliedFilters, t, subtitleKey, sampleSize }) {
  const barChartData = {
    categories: [],
    bars: []
  }

  const singleDataItem = {
    data: [],
    showInLegend: false
  }

  data.forEach(d => {
    barChartData.categories.push(d.itemName)
    singleDataItem.data.push({ y: d.percentage, count: d.count })
  })
  barChartData.bars.push(singleDataItem)

  const formatTooltip = context => {
    if (context.point.count === 1) {
      return `<b>${context.x}:</b> 
      ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.Person")})`
    }
    
    return `<b>${context.x}:</b> 
    ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.People")})`
  }

  const titleKey = "Widgets.MeetingNeeds.Title"
  return (
    <Widget
      columns={2}
      titleKey={titleKey}
      helpKey="Widgets.MeetingNeeds.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <ColumnChart
        data={barChartData}
        yAxisTitle="Common.Percentage"
        xAxisTitle="Widgets.MeetingNeeds.Scale"
        chartType="column"
        tooltipFormatter={formatTooltip}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      />
    </Widget>
  )
}

MeetingNeeds.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNamePercentageCountShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default translate()(MeetingNeeds)



// WEBPACK FOOTER //
// ./src/components/widgets/MeetingNeeds.jsx